import type { Artwork } from "../types/artwork";

const PLACEHOLDER_IMAGE = "https://via.placeholder.com/600";

export function getOptimizedCloudinaryUrl(url: string, width: number): string {
  if (!url.includes("res.cloudinary.com") || !url.includes("/upload/")) {
    return url;
  }

  return url.replace("/upload/", `/upload/f_auto,q_auto,w_${width}/`);
}

export function getArtworkImage(artwork: Artwork, width = 600): string {
  const imageUrl =
    artwork.image_url || artwork.images?.[0]?.url || PLACEHOLDER_IMAGE;

  return getOptimizedCloudinaryUrl(imageUrl, width);
}
